'use strict';

require('../../company/CompanyInfoService.js');
require('../../company/users/CompanyUserService.js');

function CompanyGuestUsersListCtrl(
  $scope,
  company,
  users,
  translations,
  $stateParams,
  $translate,
  CompanyUserService,
  UserService,
  growl,
  $state,
  usersInvited
) {
  $scope.company = company;
  $scope.more = false;
  $scope.page = parseInt($stateParams.page, 10) || 1;
  $scope.filterType = $stateParams.type || '';
  $scope.filterText = $stateParams.emailPrefix;
  $scope.usersInvited = usersInvited;
  $scope.users = users;


  $scope.userTypes = [
    {
      label: translations['user.guest'],
      value: 'GUEST'
    },
    {
      label: translations['user.default'],
      value: 'DEFAULT'
    }
  ];

  if($scope.users.length === 21) {
    $scope.more = true;
    $scope.users.pop();
  }

  $scope.resend = function(user) {
    user.company_id = $scope.company.id;
    UserService.createInvite({code: user.code}, user).$promise.then(function() {
      CompanyUserService.queryUsersInvited({companyId: $stateParams.companyId}, function(resp){
        $scope.usersInvited = resp;
      });
      growl.addSuccessMessage($translate.instant('signup.invite-success', {email: user.email}));
    });
  };

  $scope.removeInvited = function(user, index) {
    CompanyUserService.removeInvited({
      companyId: $stateParams.companyId,
      email: user.email}).$promise.then(function(){
        $scope.usersInvited.splice(index, 1);
        growl.addSuccessMessage($translate.instant('user.remove-invited-success', {email: user.email}));
      }, function(){
        growl.addErrorMessage($translate.instant('user.remove-invited-failure', {email: user.email}));
      });
  };

  $scope.upgradeUser = function(user) {
    if ($scope.info.usage.users >= $scope.info.features.maxUsers) {
      growl.addErrorMessage(translations['user.upgrade-failure']);
    } else {
      var data = angular.copy(user);

      data.type = "DEFAULT";

      return CompanyUserService.update({companyId: $stateParams.companyId, userId: data.id}, data).$promise.then(function() {
        user.type = "DEFAULT";
        $scope.$emit('companyInfoChanged');
        growl.addSuccessMessage(translations['user.upgrade-success']);
      }, function() {
        growl.addErrorMessage(translations['user.upgrade-failure']);
      });
    }
  };

  $scope.search = function(text, type) {
    $state.go(".", {
      page:        null,
      emailPrefix: text,
      type:        type || null
    });
  };
}

CompanyGuestUsersListCtrl.resolve = {
  users: ['$stateParams', 'CompanyUserService', function($stateParams, CompanyUserService) {
    var companyId = $stateParams.companyId;
    var page      = parseInt($stateParams.page, 10) || 1;
    var filter    = {
      companyId: companyId,
      profileStatus: true,
      // Fetch 21 for pagination, but the offset should be using 20
      limit:     21,
      offset:    (page - 1) * 20
    };

    if($stateParams.emailPrefix) {
      filter.q = $stateParams.emailPrefix;
    }
    if($stateParams.type) {
      filter.type = $stateParams.type;
    }

    return CompanyUserService.query(filter).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'user.remove-from-company-success',
      'user.remove-from-company-failure',
      'user.guest',
      'user.default',
      'user.upgrade-failure',
      'user.upgrade-success',
      'signup.invite-success'
    ]);
  }],
  company: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
    return CompanyService.get({companyId: $stateParams.companyId});
  }],
  usersInvited: ['$stateParams', 'CompanyUserService', function($stateParams, CompanyUserService){
    return CompanyUserService.queryUsersInvited({companyId: $stateParams.companyId}).$promise;
  }]
};

module.exports = CompanyGuestUsersListCtrl;

angular.module('dokiv')
  .controller('CompanyGuestUsersListCtrl', [
    '$scope',
    'company',
    'users',
    'translations',
    '$stateParams',
    '$translate',
    'CompanyUserService',
    'UserService',
    'growl',
    '$state',
    'usersInvited',
    CompanyGuestUsersListCtrl
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/users/CompanyGuestUsersListCtrl.js
// module id = 303
// module chunks = 0